var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachinesRemoteSupportIconOrange = function SvgMachinesRemoteSupportIconOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD7F38",
    d: "M4 9.501a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333M4 11.168c-1.048 0-1.963.622-2.455 1.548-.202.379.117.785.547.785h3.817c.43 0 .748-.406.547-.785-.492-.926-1.408-1.548-2.456-1.548"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    strokeLinecap: "round",
    d: "M4 9.501a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM4 11.168c-1.048 0-1.963.622-2.455 1.548-.202.379.117.785.547.785h3.817c.43 0 .748-.406.547-.785-.492-.926-1.408-1.548-2.456-1.548Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"
  })));
};
export { SvgMachinesRemoteSupportIconOrange as ReactComponent };
export default __webpack_public_path__ + "b09b6ddbefd4ea8f847768349b515796.svg";